import { render, staticRenderFns } from "./ColourControl.vue?vue&type=template&id=0a4a743e&scoped=true&"
import script from "./ColourControl.js?vue&type=script&lang=js&"
export * from "./ColourControl.js?vue&type=script&lang=js&"
import style0 from "./ColourControl.scss?vue&type=style&index=0&id=0a4a743e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4a743e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
